var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"auto","max-width":"1440px"}},[_c('div',{staticClass:"ev2-body leilao-dash"},[_c('div',{staticClass:"content-grid"},[_c('resumo'),_c('ultimos-lances'),_c('requer-atencao'),_c('estatistica-leilao'),_c('estatistica-lotes'),_c('documentos-leilao'),_c('resumo-habilitacoes'),_c('resumo-marketplace')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }